import {
  Bath,
  Bike,
  BookOpen,
  BrushCleaning,
  Building2,
  CalendarDays,
  Car,
  Cctv,
  Clapperboard,
  CookingPot,
  ContactRound,
  Dumbbell,
  Flame,
  Gamepad2,
  Handshake,
  House,
  Microwave,
  Package,
  PackageOpen,
  PanelTopOpen,
  Printer,
  Shield,
  Shirt,
  ShoppingBasket,
  ShowerHead,
  Sparkles,
  Sprout,
  Trees,
  Tv,
  UserCircle,
  Users,
  UtensilsCrossed,
  WashingMachine,
  Wifi,
  type LucideIcon,
} from 'lucide-react'
import type { IconType } from 'react-icons'
import { GiVendingMachine } from 'react-icons/gi'

export const amenityIconSelectOptions = [
  { label: 'Balcony', value: 'balcony' },
  { label: 'Bathtub', value: 'bathtub' },
  { label: 'Bike', value: 'bike' },
  { label: 'Book open', value: 'bookOpen' },
  { label: 'Brush cleaning', value: 'brushCleaning' },
  { label: 'Building', value: 'building' },
  { label: 'Calendar days', value: 'calendarDays' },
  { label: 'Car', value: 'car' },
  { label: 'CCTV', value: 'cctv' },
  { label: 'Clapperboard', value: 'clapperboard' },
  { label: 'Community kitchen', value: 'cookingPot' },
  { label: 'Contact round', value: 'contactRound' },
  { label: 'Dishwasher', value: 'dishwasher' },
  { label: 'Dumbbell', value: 'dumbbell' },
  { label: 'Gamepad', value: 'gamepad' },
  { label: 'Handshake', value: 'handshake' },
  { label: 'House', value: 'house' },
  { label: 'Oven', value: 'oven' },
  { label: 'Package', value: 'package' },
  { label: 'Package open', value: 'packageOpen' },
  { label: 'Printer', value: 'printer' },
  { label: 'Shield', value: 'shield' },
  { label: 'Shirt', value: 'shirt' },
  { label: 'Shower', value: 'shower' },
  { label: 'Shopping basket', value: 'shoppingBasket' },
  { label: 'Sparkles', value: 'sparkles' },
  { label: 'Sprout', value: 'sprout' },
  { label: 'Stove', value: 'stove' },
  { label: 'Trees', value: 'trees' },
  { label: 'TV', value: 'tv' },
  { label: 'User Circle', value: 'userCircle' },
  { label: 'Users', value: 'users' },
  { label: 'Vending machine', value: 'vendingMachine' },
  { label: 'Washing machine', value: 'washingMachine' },
  { label: 'WiFi', value: 'wifi' },
] as const

export type AmenityIcon = (typeof amenityIconSelectOptions)[number]['value']

export type AmenityIconComponent = LucideIcon | IconType

export const amenityIconComponents: Record<AmenityIcon, AmenityIconComponent> = {
  balcony: PanelTopOpen,
  bathtub: Bath,
  bike: Bike,
  bookOpen: BookOpen,
  brushCleaning: BrushCleaning,
  building: Building2,
  calendarDays: CalendarDays,
  car: Car,
  cctv: Cctv,
  clapperboard: Clapperboard,
  cookingPot: CookingPot,
  contactRound: ContactRound,
  dishwasher: UtensilsCrossed,
  dumbbell: Dumbbell,
  gamepad: Gamepad2,
  handshake: Handshake,
  house: House,
  oven: Microwave,
  package: Package,
  packageOpen: PackageOpen,
  printer: Printer,
  shield: Shield,
  shirt: Shirt,
  shower: ShowerHead,
  shoppingBasket: ShoppingBasket,
  sparkles: Sparkles,
  sprout: Sprout,
  stove: Flame,
  trees: Trees,
  tv: Tv,
  userCircle: UserCircle,
  users: Users,
  vendingMachine: GiVendingMachine,
  washingMachine: WashingMachine,
  wifi: Wifi,
}

export function isAmenityIcon(value: string): value is AmenityIcon {
  return value in amenityIconComponents
}

export function getAmenityIconComponent(value: string | null | undefined): AmenityIconComponent | null {
  if (!value || !isAmenityIcon(value)) {
    return null
  }

  return amenityIconComponents[value]
}
